import { render, staticRenderFns } from "./TheSendCode.vue?vue&type=template&id=7b4d4ad4&scoped=true&"
import script from "./TheSendCode.vue?vue&type=script&lang=js&"
export * from "./TheSendCode.vue?vue&type=script&lang=js&"
import style0 from "./TheSendCode.vue?vue&type=style&index=0&id=7b4d4ad4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4d4ad4",
  null
  
)

export default component.exports